import { useAuth } from '@/hooks/useAuth';
import MissionsPanel from '@/components/feature/MissionsPanel';

/** Page « Missions » du tableau de bord commerçant. */
export default function DashboardMissionsPage() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="p-4 md:p-6">
      <MissionsPanel user={user} typecompte={user.typecompte} detailBasePath="/dashboard/missions" />
    </div>
  );
}